import React from "react"

import { connect } from "scrivito"

import { Header } from "./Header"
import { useHeaderModel } from "./model/useHeaderModel"

function HeaderConnectorComponent() {
  return <Header {...useHeaderModel()} />
}

export const HeaderConnector = React.memo(
  connect(HeaderConnectorComponent)
) as unknown as typeof HeaderConnectorComponent
